<template>
  <v-container>
    <v-card>
      <v-card-title>{{ t('subAgentManagement.title') }}</v-card-title>
      <v-tabs v-model="activeTab">
      <v-tab>{{ t('subAgentManagement.subAgentList') }}</v-tab>
      <v-tab v-if="canAddSubAgent && activeTab === 1">{{ t('subAgentManagement.addSubAgents') }}</v-tab>
        <v-btn v-if="canAddSubAgent && activeTab == 0" icon color="warning" @click="activeTab = 1">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-tabs>
      <v-tabs-items v-model="activeTab">
        <v-tab-item v-if="activeTab === 0">
          <v-data-table :headers="headers" :items="subAgents" class="elevation-1">
              <template v-slot:[`item.actions`]="{ item }">
                <v-btn color="primary" @click="editSubAgent(item)">{{ t('subAgentManagement.edit') }}</v-btn>
              </template>
          </v-data-table>
        </v-tab-item>
        <v-tab-item v-if="activeTab === 1 && canAddSubAgent">
          <v-card>
            <v-card-title>{{ t('subAgentManagement.addSubAgents') }}</v-card-title>
            
            <v-card-text>
              <v-text-field :label="t('subAgentManagement.selfEarningsRate')" v-model="currentAgent.agentFee" disabled></v-text-field>
              <v-text-field :label="t('subAgentManagement.address')" v-model="newSubAgent.address"></v-text-field>
              <v-text-field :label="t('subAgentManagement.earnings')" v-model="newSubAgent.earnings" type="number" :placeholder="t('subAgentManagement.earningsNotAllowHigherThanSelfEarningsRate')"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="addSubAgent">{{ t('subAgentManagement.confirm') }}</v-btn>
              <v-btn @click="resetForm">{{ t('subAgentManagement.cancel') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
        <v-tab-item v-if="activeTab === 2 && editingSubAgent">
          <v-card>
            <v-card-title>{{ t("subAgentManagement.editSubAgents") }}</v-card-title>
            <v-card-text>
              <v-text-field :label="t('subAgentManagement.address')" v-model="editSubAgentFrom.address" disabled></v-text-field>
              <v-text-field :label="t('subAgentManagement.earnings')" v-model="editSubAgentFrom.earnings" type="number"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" @click="updateSubAgentEarnings">{{ t("subAgentManagement.confirm") }}</v-btn>
              <v-btn @click="resetForm">{{ t("subAgentManagement.cancel") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, onMounted, computed, defineProps, getCurrentInstance } from 'vue';
import { useI18n } from 'vue-i18n';
import { checkUserFromAgent, updateUserRoles } from '@/api/apiService';

const { t, locale } = useI18n();

const { proxy } = getCurrentInstance();

const props = defineProps({
  walletConnect: {
    type: Array,
    required: true,
  },
});
const activeTab = ref(0);
const headers = computed(() => {
  const currentLanguage = locale.value;
  return [
    { title: t('subAgentManagement.address', { lang: currentLanguage }), value: 'address' },
    { title: t('subAgentManagement.earnings', { lang: currentLanguage }), value: 'earnings' },
    { title: t('subAgentManagement.action', { lang: currentLanguage }), value: 'actions' },
  ];
});


const subAgents = ref([]);

const userPermissions = ref(['view', 'add', 'edit']);
const showAddDialog = ref(false);
const newSubAgent = ref({
  address: '',
  earnings: '',
});
const editSubAgentFrom = ref({
  address: '',
  earnings: '',
});
const oldSubAgent = ref({
  address: '',
  earnings: '',
});
const currentAgent = ref({});
onMounted(async () => {
  // proxy.$eventBus.on('onWalletInitialized', async () => {
    subAgents.value = [];
    try {
      const agentInfo = await props.walletConnect.getAgentInfo(props.walletConnect.walletAddress);
      console.log(agentInfo, "agentInfo");
      currentAgent.value = agentInfo;
      if (agentInfo.childAgents.length > 0) {
          for(let i=0; i<agentInfo.childAgents.length; i++) {
            let childAgent = await props.walletConnect.getAgentInfo(agentInfo.childAgents[i]);
            console.log(childAgent, "childAgent");
            // let unReward = await props.walletConnect.buyContract.unRewardInfo(agentInfo.childAgents[i]).call();
            let earnings = childAgent.agentFee;
            let decimals = await props.walletConnect.usdtContract.methods.decimals();
            decimals = Number(decimals);
            subAgents.value.push({
              address: agentInfo.childAgents[i],
              earnings: Number(earnings),
            });
        }
      }
    } catch (error) {
      console.error(error);
    }
  // });
});

  const canAddSubAgent = computed(() => {
    return userPermissions.value.includes('add');
  });

  const editingSubAgent = computed(() => {
    return userPermissions.value.includes('edit');
  });

const resetForm = () => {
  newSubAgent.value = {
    address: '',
    earnings: '',
  };
  showAddDialog.value = false;
  activeTab.value = 0;
  userPermissions.value = ['view', 'add'];
};

const addSubAgent = async () => {
  try {
    const checkUser = await checkUserFromAgent(newSubAgent.value.address);
      if(checkUser.code === 0) {
        proxy.$toast.error(t('subAgentManagement.addSubAgent.subAgentNotExists'));
      return;
    } else {
      if(validateEarnings(newSubAgent.value.earnings*10, currentAgent.value.earnings)) {
        await props.walletConnect.addAgent(newSubAgent.value.address, newSubAgent.value.earnings*10);
          subAgents.value.push({
            address: newSubAgent.value.address,
          earnings: newSubAgent.value.earnings,
        });
        await updateUserRoles(newSubAgent.value.address, 'subAgent');
      }
    }
  } catch (error) {
    console.error(error);
    proxy.$toast.error(t('subAgentManagement.addSubAgent.addSubAgentFailed'));
  }
  showAddDialog.value = false;
  newSubAgent.value = {
    address: '',
    earnings: '',
  };
  oldSubAgent.value = {
    address: '',
    earnings: '',
  };
  activeTab.value = 0;
  userPermissions.value = ['view', 'add'];
};

const validateEarnings = (newEarnings, currentEarnings = 0) => {
  if (newEarnings < currentEarnings) {
    proxy.$toast.error(t('subAgentManagement.addSubAgent.notAllowLessThanCurrentEarnings'));
    return false;
  }
  if (newEarnings > currentAgent.value.earnings) {
    proxy.$toast.error(t('subAgentManagement.addSubAgent.notAllowExceedCurrentAgentEarnings'));
    return false;
  }
  return true;
};
const editSubAgent = (item) => {
    editSubAgentFrom.value = item;
    activeTab.value = 2;
    userPermissions.value = ['view', 'edit'];
    oldSubAgent.value = item;
};
const updateSubAgentEarnings = async () => {
  if(validateEarnings(editSubAgentFrom.value.earnings*10, oldSubAgent.value.earnings)) {
    await props.walletConnect.updateAgentEarnings(editSubAgentFrom.value.address, editSubAgentFrom.value.earnings*10);
    activeTab.value = 0;
    userPermissions.value = ['view', 'add'];
    editSubAgentFrom.value = {
      address: '',
      earnings: '',
    };
    oldSubAgent.value = {
      address: '',
      earnings: '',
    };
  }
};
</script>
